module.exports = "<spent-time-calendar></spent-time-calendar> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/2-time/inspect.calendar.overview.html
// module id = 4079
// module chunks = 86